// sessionStorage 管理工具
const storageHelper = {
  // 命名空间前缀，避免与其他存储冲突
  prefix: "temp_",

  /**
   * 保存临时数据
   * @param {string} key - 存储键名
   * @param {any} data - 要存储的数据
   * @param {number} [expire=0] - 过期时间（秒），0表示不过期
   */
  setTempData(key, data, expire = 0) {
    try {
      const storageKey = this.prefix + key;
      const storageData = {
        value: data,
        timestamp: Date.now(),
        expire: expire * 1000, // 转换为毫秒
      };
      sessionStorage.setItem(storageKey, JSON.stringify(storageData));
      return true;
    } catch (error) {
      console.error("保存临时数据失败:", error);
      return false;
    }
  },

  /**
   * 获取临时数据
   * @param {string} key - 存储键名
   * @returns {any|null} 存储的数据或null
   */
  getTempData(key) {
    const storageKey = this.prefix + key;
    const dataStr = sessionStorage.getItem(storageKey);

    if (!dataStr) return null;

    try {
      const storageData = JSON.parse(dataStr);

      // 检查数据是否过期
      if (
        storageData.expire > 0 &&
        Date.now() - storageData.timestamp > storageData.expire
      ) {
        this.removeTempData(key);
        return null;
      }

      return storageData.value;
    } catch (error) {
      console.error("解析临时数据失败:", error);
      this.removeTempData(key);
      return null;
    }
  },

  /**
   * 删除临时数据
   * @param {string} key - 存储键名
   */
  removeTempData(key) {
    const storageKey = this.prefix + key;
    sessionStorage.removeItem(storageKey);
  },

  /**
   * 清空所有临时数据
   */
  clearAllTempData() {
    Object.keys(sessionStorage).forEach((key) => {
      if (key.startsWith(this.prefix)) {
        sessionStorage.removeItem(key);
      }
    });
  },
};

export default storageHelper;
